import { ReactNode } from 'react';
import { NativeDialogWrapper } from './NativeDialogWrapper';
import { closeDialog, useDialogStack } from './dialogStack';

/** Renders dialogs opened through openDialog/useDialog. Mount once, inside the theme providers */
export const DialogProvider = ({ children }: { children: ReactNode }) => {
  const stack = useDialogStack();

  return (
    <>
      {children}
      {stack.map((dialog) => (
        <NativeDialogWrapper
          key={dialog.id}
          dialog={dialog}
          onSystemClose={closeDialog}
        />
      ))}
    </>
  );
};
